export default {
  title: 'ATM',
  message: {
    noData: 'No Data',
    delete: 'Are you sure to delete?',
    noRecordFound: 'No record found',
    changePasswordSuccess: 'Change password successful.',
    updateProfileSuccess: 'Update profile successful.',
    forgotPasswordSuccess:
      'Check your email for a link to reset your password. If it does not appear within a few minutes, check your spam folder.',
    resetPasswordSuccess: 'Reset password successful.',
    list: 'Get list {name} successful.',
    create: 'Create {name} successful.',
    update: 'Update {name} successful.',
    destroy: 'Delete {name} successful.',
    noteWhitelist: 'Input only * if you want to allow all whitelist public ip/domain',
    acceptHttps: 'Only accept https',
    alreadyHaveAccount: 'Already have a login ID and password',
    easyManagement: 'Easy management, it is as simple as that!',
    copySuccess: 'The access token is copied',
    resetPassword: 'Are you sure to reset password',
    copyDecodeSuccess: 'The decoded token is copied',
  },
  placeholder: {
    searchCompany: 'Please select company',
    searchRegion: 'Please select region',
    inputName: 'Please input {name} name',
    selectDivision: 'Please select suite',
    selectProject: 'Please select project',
    selectAuthenticatorType: 'Please select authenticator type',
    inputFirstName: 'Please input first name',
    inputLastName: 'Please input last name',
    inputEmail: 'Please input email',
    inputPassword: 'Please input password',
    inputConfirmPassword: 'Please input confirm password',
    inputCurrentPassword: 'Please input current password',
    inputNewPassword: 'Please input new password',
    inputConfirmNewPassword: 'Please input confirm new password',
    inputRedirectUrl: 'Please input redirect url',
    selectApplication: 'Please select application',
    inputScope: 'Please input scope name',
    inputWhiteList: 'Please input public ip/domain',
    inputFieldName: 'Please input name',
    inputCodeChallenge: 'Please input code challenge',
    inputCodeChallengeMethod: 'Please input code challenge method',
    inputCodeVerifier: 'Please input code verifier',
  },
  header: {
    createProfile: 'Create your profile',
    login: 'Log into your account',
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    signin: 'SIGN IN',
    project: 'Projects',
    dashboard: 'Dashboard',
    user: 'Users',
    division: 'Suites',
    application: 'Applications',
    endUser: 'Application Users',
    configApplication: 'Config',
    genToken: 'Generate Token',
    loginAuthorization: 'Login',
    general: 'General',
    setting: 'Settings',
    createApp: 'Create Application',
    editApp: 'Edit Application',
    tutorial: 'Tutorial',
    verifyToken: 'Verify Token',
    decodedToken: 'Decoded Token',
    accessToken: 'Access Token',
    client: 'Clients',
    createClient: 'Create Client',
    editClient: 'Edit Client',
  },
  paging: {
    records: 'records',
    prev: 'Previous',
    next: 'Next',
    rows: '{rows} rows',
  },
  button: {
    signup: 'Sign up',
    logout: 'Logout',
    createAccount: 'Create new account',
    save: 'Save',
    close: 'Close',
    cancel: 'Cancel',
    create: 'Create',
    ok: 'OK',
    back: 'Back',
    edit: 'Edit',
    sendResetEmail: 'Send reset email',
    add: 'Add',
    delete: 'Delete',
    forgotPassword: 'Forgot Password',
    signin: 'Sign in',
    resetPassword: 'Reset Password',
    submit: 'Submit',
    copy: 'Copy',
  },
  error: {
    notFound: 'Not Found',
    notPermission: 'Not Permission',
    notExist: 'The {field} does not exist',
    emailWasUsed: 'Email was used.',
    currentPassNotMatch: 'Current password not match.',
    changePasswordUnsuccess: 'Change password unsuccessful.',
    updateProfileUnsuccess: 'Update profile unsuccessful.',
    forgotPasswordUnsuccess: 'Forgot password unsuccessful.',
    resetPasswordUnsuccess: 'Reset password unsuccessful.',
    wrongEmailPassword: 'Email or password does not match.',
    lockedAccount: 'Your account is locked. Please contact with system administrator to unlock.',
    list: 'Get list {name} unsuccessful.',
    create: 'Create {name} unsuccessful.',
    update: 'Update {name} unsuccessful.',
    destroy: 'Delete {name} unsuccessful.',
    exist: 'The {name} already exists',
    hasMany: '{field} has already {another_field}',
    used: 'The {name} used',
    expire: 'The {name} is expired',
    sessionTimeout: 'Session timeout. Please login again.',
    appUpdateClientCredential:
      'The application can not update client credentials type because it already has a user',
    lessThan: 'The {field} must be less than {another_field}',
    accessToken: 'Get access token unsuccessful',
    loginAuthorizationFail: 'Login unsucessful',
    notCopyToken: 'The access token can not be copied',
    deletedUser: 'Your account has been deleted. Please contact Admin',
    verifyToken: 'Token is invalid',
    copyDecodeFail: 'The decoded token can not be copied',
    expiredResetPassword: 'The reset password link is expired. Please reset password again.',
    appHasClient: 'This application has client',
  },
  label: {
    id: 'ID',
    company: 'Company',
    region: 'Region',
    name: 'Name',
    whitelist: 'Whitelist Public IP/Domain',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    role: 'Role',
    url: 'Url',
    project: 'Project',
    division: 'Suite',
    user: 'User',
    application: 'Application',
    configApplication: 'Config',
    scopeName: 'Scope name',
    scopes: 'Scopes',
    password: 'Password',
    redirectUrl: 'Redirect Url',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    authenticatorType: 'Authenticator Type',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    confirmPassword: 'Confirm Password',
    yourProfile: 'Your Profile',
    createProject: 'Create Project',
    editProject: 'Edit Project',
    createUser: 'Create User',
    editUser: 'Edit User',
    createApp: 'Create Application',
    editApp: 'Edit Application',
    createEndUser: 'Create Application User',
    editEndUser: 'Edit Application User',
    createDivision: 'Create Suite',
    editDivision: 'Edit Suite',
    idAccessTokenLifeSpan: 'Id Access Token Life Span',
    accessTokenLifeSpan: 'Access Token Life Span',
    refreshTokenLifeSpan: 'Refresh Token Life Span',
    copyright: 'Copyright © 2022 Transcosmos inc. All rights reserved.',
    note: 'Note',
    minutes: 'minutes',
    times: 'times',
    successLogs: 'Success Logs',
    errorLogs: 'Error Logs',
    totalLogsInThisWeek: 'Total Logs In This Week',
    successLogsInThisWeek: 'Success Logs In This Week',
    errorLogsInThisWeek: 'Error Logs In This Week',
    logStatistics: 'Log Statistics',
    examples: 'Examples',
    superAdmin: 'Super Admin',
    divisionAdmin: 'Suite Admin',
    systemUser: 'Project Admin',
    endUser: 'Application User',
    publicIp: 'Public IP',
    domain: 'Domain',
    status: 'Status',
    codeChallenge: 'Code Challenge',
    codeChallengeMethod: 'Code Challenge Method',
    codeVerifier: 'Code Verifier',
    code: 'Code',
    accessToken: 'Access Token',
    client: 'Client',
  },
  validation: {
    required: 'The {field} is required',
    email: {
      format: 'Please input correct email address',
    },
    min: 'The {field} must be least {min} characters',
    confirmPass: 'The confirm password is inconsistent with the password',
    max: 'The {field} must be less than {max} characters',
    incorrect: 'The {field} is incorrect',
    passwordRule:
      'The password requires at least one uppercase(A-Z), lowercase(a-z), one digit(0-9) and one special character',
    timeLifeSpanRefreshToken: 'The time need greater than 0',
    timeLifeSpanAccessToken: 'The time value you enter must be greater than 0 and less than 601.',
    positive: 'The {field} field must be a positive number',
  },
}
